import React from 'react';
import { Button, Skeleton } from 'antd';
import './LoginPageMobile.less';
import { useAppSelector } from '../../store/hooks';
import { ReactComponent as AppStore } from '../../lib/img/stores/appstore.svg';
import { ReactComponent as GoogleStore } from '../../lib/img/stores/google.svg';
import { ReactComponent as CompanyLogo } from '../../lib/img/logo-iflex.svg';
import { ReactComponent as RuStore } from '../../lib/img/stores/rustore.svg';
import { checkIsLoading } from '../../lib/utils/checkLoadingStatus';

const LoginPageMobile = () => {
  const { properties, propertiesLoading } = useAppSelector((state) => state.root);

  return (
    <div className="login-page-mobile">
      <div className="container-mobile login-page-mobile-color">
        <div className="login-page-inner-container">
          <div className="logo" />
          <div className="login-page-mobile__title-block">
            {checkIsLoading(propertiesLoading) ? (
              <Skeleton.Node style={{ display: 'block', width: '320px', height: '128px' }} active={true}>
                <div></div>
              </Skeleton.Node>
            ) : (
              <h1 className="login-page-mobile__title header2">{`${properties.invitation_web}`}</h1>
            )}
          </div>
        </div>

        <div className="container-logo">
          <a href={`${properties.google_play_market}`} target="_blank" rel="noopener noreferrer">
            <GoogleStore height={50} />
          </a>
          <a href={`${properties.rustore_market}`} target="_blank" rel="noopener noreferrer">
            <RuStore height={50} />
          </a>
          <a href={`${properties.app_store_market}`} target="_blank" rel="noopener noreferrer">
            <AppStore height={50} />
          </a>
        </div>

        <div className="login-page-mobile__btn-container">
          <Button className="login-page-mobile__btn-link button16-regular" size={'large'}>
            <a className="login-page-mobile__link" href={`${properties.info}`} target="_blank">
              Узнать о службе добровольцев
            </a>
          </Button>
        </div>

        <div className="login-page-innerContainer">
          <a
            className="login-page-mobile__politics"
            href={`${properties.privacy_policy}`}
            target="_blank"
            style={{ whiteSpace: 'nowrap' }}
          >
            Политика конфиденциальности
          </a>

          <div className="login-page-mobile__company">
            <div className="login-page-mobile__company-title">Разработчик</div>
            <a className="login-page-mobile__company-logo" href={`${properties.iflex_website_adress}`} target="_blank">
              <CompanyLogo />
              <span>&nbsp;айФлекс</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPageMobile;
